import { Surface } from '@dx-ui/global-ui-prism';
import { SkeletonLoader } from '@dx-ui/osc-skeleton-loader';
import type { FormDataStructure } from '@dx-ui/osc-form';

type DebugConsole = {
  results: FormDataStructure | undefined;
};

export const SkeletonFields = ({ numberOfFields = 5 }: { numberOfFields?: number }) => {
  const Fields: React.ReactElement[] = [];
  for (let i = 0; i < numberOfFields; i += 1)
    Fields.push(<SkeletonLoader key={`skeleton-${i}`} className="h-16 w-full" variant="rounded" />);
  return Fields;
};

export const DebugConsole: React.FC<React.PropsWithChildren<DebugConsole>> = ({ results }) =>
  results && (
    <Surface type="alternate" className="mt-4">
      <pre className="text--sm inline-block p-4 font-mono leading-relaxed">
        {JSON.stringify(results, undefined, 2)}
      </pre>
    </Surface>
  );
